import { HHButton, HHStack } from '@hinge-health/react-component-library';
import { ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';

interface FloatingReturnButtonProps {
  isVisible: boolean;
  navigateUrl: string;
  buttonText?: string;
}

export const FloatingReturnButton = ({
  isVisible = false,
  navigateUrl,
  buttonText = 'Return',
}: FloatingReturnButtonProps): JSX.Element | null => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!isVisible) {
    return null;
  }

  const handleClick = (): void => {
    navigate(navigateUrl, {
      state: { ...location.state },
    });
  };

  return (
    <HHStack
      sx={{
        position: 'fixed',
        bottom: 10,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
      }}
    >
      <HHButton
        hhVariant="contained"
        color="primary"
        startIcon={<ArrowBack />}
        onClick={handleClick}
      >
        {buttonText}
      </HHButton>
    </HHStack>
  );
};
